const getFlagForKeyCode = (keyCode) => {
    switch (keyCode) {
        case 'W'.charCodeAt(0):
            return 'moveUp';
        case 'S'.charCodeAt(0):
            return 'moveDown';
        case 'Q'.charCodeAt(0):
            return 'moveForward';
        case 'E'.charCodeAt(0):
            return 'moveBackward';
        case 'D'.charCodeAt(0):
            return 'moveRight';
        case 'A'.charCodeAt(0):
            return 'moveLeft';
        case 'T'.charCodeAt(0):
            return 'orbit'
        default:
            return undefined;
    }
}

export default getFlagForKeyCode;
